import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import dataV from '@jiaminghi/data-view'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/utils/permission' //路由拦截


const app = createApp(App)
for (const [name, comp] of Object.entries(ElementPlusIconsVue)) {
	app.component(name, comp);
}
app.use(store).use(router).use(dataV).mount('#app')
